<template>
  <div class="hello">
    <Header></Header>
    <div class="content_s clearfix">
      <div class="zj-list">
        <h2><i class="el-icon-s-custom"></i>专家列表</h2>
        <el-row>
          <el-col :span="24" :key="index">

            <el-card :body-style="{ padding: '0px'}" v-for="(v,k) in researcher" :key="k" @click.native="redirect_detail(v.uniquecode)">
              <img :src="v.avatar_url">
              <div>
                <h3>{{v.name}}</h3>
                <span>{{v.intruduce}}</span>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
      <div class="news-list">
       
        <el-row>
          <el-col :span="24"  :key="index">
            <el-card :body-style="{ padding: '0px'}" v-for="(vl,ke) in articalAbout" :key="ke" @click.native="redirect_artical(vl.uniquecode)">
              <div  class="new-img"> 
                <img :src="vl.thumb_image_url" class="image">
              </div>
              <div class="shake">
                <h3>{{vl.title}}</h3>
              </div>
            </el-card>
          </el-col>

        </el-row>

        <!-- <el-button type="primary"
                   @click="openFullScreen1"
                   v-loading.fullscreen.lock="fullscreenLoading">
          加载更多
        </el-button> -->

      </div>

    </div>


    <bbottom></bbottom>
  </div>
</template>

<script>

  import Header from "@/components/public/Header.vue"
  import bbottom from "@/components/public/bbottom.vue"
  export default {
    name: 'yanjiuyuan',
    data() {
      return {
        activeName: 'first',
        data: ['1', '2', '3', '4'],
        msg: 'shuiahuiah',
        currentDate: new Date(),
        researcher:[],
        articalAbout:[]
      }
    },
    props: {},
    //页面初始化
    computed: {
    },
    created(){
      this.getArticalInfoList()
      this.getAboutArtical()
    },

    //页面加载后执行方法
    methods: {
      redirect_artical(_uniquecode){
        this.$router.push({path:'/article/'+_uniquecode})
      },
      //研究院相关文章
      getAboutArtical(){
        var config = {
          method: 'GET',
          url: '/api/v1/artical/about/researcher',
          headers: { 
            'Content-Type': 'application/json'
          }
        };
            
        this.$axios(config).then(res=>{
          this.articalAbout = res.data
        }).catch(error=>{
          console.log('请求失败')
        })
      },
      getArticalInfoList(){
        var config = {
          method: 'GET',
          url: '/api/v1/researcher/list',
          headers: { 
            'Content-Type': 'application/json'
          }
        };
            
        this.$axios(config).then(res=>{
          this.researcher = res.data
        }).catch(error=>{
          console.log('请求失败')
        })
      },
      redirect_detail(uniquecode){
        this.$router.push({path:'/research/detail/'+uniquecode})
      },
      handleClick(tab, event) {
        console.log(tab, event);
      },
      submit_data() {
        // this.$router.push('/collect')
      },
      handleClick(tab, event) {
        console.log(tab, event);
      }

    },
    //组件引入
    components: {

      Header,
      bbottom
    },
  }

</script>

<style scoped>

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .content_s {
    width: 1200px;
    margin: 25px auto;
  }

  .img_s {
    width: 100%;
    border-radius: 6px;
  }

  .baomin {
    display: relative;
    width: 60%;
    height: 32px;
    border: white solid 2px;
    border-radius: 6px;
    text-align: center;
    color: white;
    position: absolute;
    top: 60%;
    left: 50%;
    margin-top: -50px;
    margin-left: -100px;
  }

  .fonts_bao {
  }

  .hello {
    color:#4b4b4b;
  }

  .time {
    font-size: 13px;
    color: #999;
  }

  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    width: 108%;
    display: block;
    position: relative;
    top: -6px;
    left: -6px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .item h3 {
    color: #e85a50;
  }

  .icon_s {
    display: inline-block;
    width: 30px;
    height: 30px;
    background: #eea01e;
    text-align: center;
    line-height: 30px;
    border-radius: 10px;
    margin-right: 15px;
    /* color:#fa5c00; */
    color: white;
  }

  .text {
    font-size: 14px;
  }

  .item {
    padding: 18px 0;
  }

  .box-card {
    width: 100%;
    margin-bottom: 20px;
  }

  .el-row {
    margin-bottom: 0px;
  }

  .el-col {
    border-radius: 4px;
  }



  /*资讯列表*/
  .news-list {
    width: 100%;
    padding: 20px 0px;
  }

  .el-tabs {
    width: 100%;
  }

  .el-tabs__header {
    margin-bottom: 30px !important;
  }

  .el-card {
    margin: 16px 8px;
    cursor: pointer;
  }

    .el-card h3 {
      margin: 0px;
      padding: 10px 10px 10px;
      font-size: 16px;
      line-height: 24px;
      min-height: 48px;
    }
  .zj-list {
      padding-bottom:20px;
      border-bottom:6px solid #f1f1f1;
  }
  .zj-list h2 {
    font-size: 20px;
    color: #bd0c16;
  }
  .zj-list .el-card h3 {
    font-size: 14px;
    line-height: 20px;
    min-height:20px;
    padding:4px 10px 4px;

  }
  .zj-list .el-card span {
    font-size: 12px;
    line-height:14px;
    display:block;
    padding:0px 10px;
  }

  .bq-tip {
    margin: 0px 0px 20px;
    padding: 0px 10px;
    font-size: 12px;
    line-height: 18px;
    color: #bd0c16;
    display: block;
  }

  .el-button--primary {
    background-color: #ffffff;
    border: 1px solid #f1f1f1;
    font-size: 18px;
    color: #999;
    display: block;
    margin: 35px auto;
  }

  .tl-banner img {
    width: 100%;
    display: block;
  }
  /***/
  .r-gs1 {
    width: 100%;
    margin: 20px auto 0px;
  }

    .r-gs1 img {
      border-radius: 6px;
      display: block;
    }



  .el-icon-alarm-clock, .el-icon-connection, .el-icon-reading, .el-icon-trophy {
    margin-right: 3px;
  }

  .el-button--default {
    background-color: #bd0c16;
    width: 118px;
    height: 40px;
    color: #ffffff;
    font-size: 16px;
    margin-top: 10px;
  }

  .el-card {
    transition: 3s;
  }

    .el-card:hover .shake {
      cursor: pointer;
      transform: translateY(10px);
      transition: all .3s ease-in;
    }

  .card-2 {
    position: relative;
  }

  .el-card:hover img {
  }

  .shake2 {
    cursor: pointer;
    position: absolute;
    bottom: 0px;
    left: 0px;
    color: #fff;
    width: 100%;
    height: 100px;
  }

    .shake2 h3 {
      opacity: 1;
      padding: 0px 20px 0px;
      font-size: 20px;
    }

  .card-2:hover .shake2 {
    transform: translateY(10px);
    transition: all .3s ease-in;
  }

  .card-2 .bq-tip {
    padding: 2px 10px;
    display: inline-block;
    background-color: #fff;
    border-radius: 6px;
    margin: 0px 0px 0px 20px;
  }

  .top {
    width: 1200px;
    margin: 0 auto;
  }

    .top img {
      display: block
    }
  .zj-list .el-card {
    width: 12.5%;
    float: left;
    margin: 0px;
    padding: 0px 8px;
    box-sizing:border-box;
    border: none;
  }
    .zj-list .el-card.is-always-shadow {
      box-shadow:none;

    }
    .zj-list .el-card img {
      display: block;
      border-radius:6px;
      width: 100%;
    }
  .zj-list .el-icon-video-camera-solid {
    margin: 0px 4px 0px 12px;
    font-size: 30px;
  }
  .zj-list .el-icon-s-custom {
    margin: 0px 4px 0px 12px;
    font-size: 24px;
  }
  .news-list .el-card {
    width: 23%;
    float: left;
    margin: 20px 1%;
    padding: 0px;
    box-sizing: border-box;
    border: none;
  }
  .new-img {
    height: 170px;
    overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/research.vue